<template>
  <div class="thank-you-pg">
    <progress-bar/>

    <h1 class="form-title">Thank you</h1>

    <p>{{ thankYouMessage }}</p>

    <div class="footer-navigation">
      <div class="continue-shopping-btn" @click="close">OK</div>
    </div>
  </div>
</template>

<script>
import ProgressBar from "../../ProgressBar";
import ConfigurationService from "./../../../services/ConfigurationService";
import VueService from "../../../services/vue/VueService";

export default {
  name: "ThankYouView",

  components: {ProgressBar},

  computed: {
    thankYouMessage() {
      return ConfigurationService.option('content.thankYouMessage', 'Data was submitted successfully');
    },
  },

  methods: {
    close() {
      VueService.close();
    },
  },
};
</script>
